import { mailApiGet, mailApiPost } from "./client";

export type MailAccountServerSettings = {
  accountId: number;
  signature: string;
  displayName?: string | null;
};

export function fetchMailAccountSettings(accountId?: number) {
  const query = accountId != null && accountId > 0 ? `?accountId=${accountId}` : "";
  return mailApiGet<{ success: boolean; settings: MailAccountServerSettings[] }>(
    `accounts/settings.php${query}`
  );
}

export function saveMailAccountSettings(
  accountId: number,
  patch: { signature?: string; displayName?: string | null }
) {
  return mailApiPost<{
    success: boolean;
    accountId: number;
    signature?: string;
    displayName?: string | null;
  }>("accounts/settings.php", { accountId, ...patch });
}

export function saveMailAccountSignature(accountId: number, signature: string) {
  return saveMailAccountSettings(accountId, { signature });
}
